<template>
  <div class="Carousel">
    <div class="slide-space">
      <slot></slot>
    </div>
    <div class="dot-space">
      <div class="dot-container">
        <div v-for="i in slide_count"
             :class="current_slide===i-1 ? 'dot-active' : 'dot-inactive'"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    slide_count:{
      type: Number,
      required: true
    },
    current_slide:{
      type: Number,
      required: true
    },
    slideInterval:{
      type: Number,
      default: 10000
    },
    theme: {
      type: Object,
      default: {
        background: 'lightcyan',
        dotspace: 'lightblue',
        dots: 'blue',
        text: 'black'
      }
    }
  },
  methods:{
    next(){
      this.$emit('next')
    }
  },
  mounted() {
    setInterval(this.next, this.slideInterval)
  },
  name: "Carousel"
}
</script>

<style scoped>
.slide-space{
  height: calc(100% - 30px);
  background-color: v-bind(theme['background']);
  position: relative;
  overflow: hidden;
  color: v-bind(theme['text']);
}
.dot-space{
  height: 30px;
  background-color: v-bind(theme['dotspace']);
}
.dot-container{
  --dots: v-bind(slide_count);
  --width: calc(var(--dots) * 20px);
  display: flex;
  position: relative;
  height: 16px;
  top: 7px;
  left: calc(50% - var(--width) / 2);
}
.dot-container>div{
  margin: 3px 5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  transition: background-color 1s cubic-bezier(.8,0,.2,1)
}
.dot-active{
  background-color: v-bind(theme['dots']);
}
.dot-inactive{
  background-color: v-bind(theme['background']);
}
</style>